import { useNavigate } from "react-router-dom";
// Hooks
import { useBreakpoint } from "hooks/useBreakpoint";
import useTranslate from "../../../hooks/useTranslate";

import "./styles.sass";
import PageTitle from "../PageTitle";

type InfoHeaderProps = {
  title: string;
};

const InfoHeader = ({ title }: InfoHeaderProps) => {
  const t = useTranslate();
  const { isDesktop } = useBreakpoint();
  const navigate = useNavigate();

  return (
    <>
      {isDesktop && (
        <span className="InfoHeader">{t(title)?.toLowerCase()}</span>
      )}
      {!isDesktop && <PageTitle title={t(title)} onBack={() => navigate(-1)} />}
    </>
  );
};

export default InfoHeader;
